import { render, staticRenderFns } from "./CardStatisticsGroup.vue?vue&type=template&id=2d0d16a2&"
import script from "./CardStatisticsGroup.vue?vue&type=script&lang=js&"
export * from "./CardStatisticsGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports